import script from "./ChangeCategoryDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeCategoryDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeCategoryDialog.vue?vue&type=style&index=0&id=d60343a4&scoped=true&lang=css"
import "./ChangeCategoryDialog.vue?vue&type=style&index=1&id=d60343a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d60343a4"]])

export default __exports__